import React, {Component} from 'react';

import Link from '../../../shared/components/hyperlink';
import AdaptiveImage from '../../../shared/components/adaptive-image';

import './content-carousel-card.less';

//import {withPropsChecker} from '../../../test/debug';


class ContentCarouselCard extends Component {

  static defaultProps = {
    thumbnail: {
      src: null,
      alt: 'HPImage',
      title: 'HPImage',
    }
  }

  render() {

    let {thumbnail={}, title="", vanityUrl="",} = this.props;

    let thumbnailType = thumbnail.constructor.toString();
    if(thumbnailType.indexOf('Object') < 0){
      thumbnail= {
         src: thumbnailType.indexOf('Array') < 0 ? thumbnail : thumbnail[0],
         alt: 'HPImage',
         title: 'HPImage',
      }
    }
    return (
      <div className='content-carousel-element-container'>
      <Link to={`${process.env.BASENAME}/${vanityUrl}`}>
        <div className='content-carousel-element'>
					<AdaptiveImage
					className="content-carousel-image" 
					src={thumbnail.src} 
					alt={thumbnail.alt} 
					title={thumbnail.title} 
					lazyload={true}
					maxWidth={150}
					/>
          <div className="content-carousel-article-title">{title}</div>
        </div>
        </Link>
      </div>
    )
  }
}

export default ContentCarouselCard;
